import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
    spaceBetween: 10,
    slidesPerView: 4,
    freeMode: true,
    watchSlidesProgress: true,
});
var swiper2 = new Swiper(".mySwiper2", {
    thumbs: {
    swiper: swiper,
    },
});

$(".details-nav ul li a").click(function() {
    let id = $(this).attr("href").split("#").pop()
    var top = $('#' + id).offset().top;
    $('html,body').animate({
        scrollTop: top - 150
    }, 500);
    $(".details-nav ul li a").removeClass("active");
    $(this).addClass("active")
})

 if ($(window).scrollTop() >= ($(".product-details .placeholder").offset().top - $("header").height())) {
    $(".product-details .details-nav").addClass("fixed");
    
    
} else {
    $(".product-details .details-nav").removeClass("fixed");
    $(".details-nav ul li a").removeClass("active");
}

$(function () {
    $(window).scroll(function () {
        // 可是窗口滚动条发生滚动的时候 垂直方向滚动到多少距离的时候 让头部导航条设置上一个固定定位的样式
        if ($(window).scrollTop() >= ($(".product-details .placeholder").offset().top - $("header").height())) {
            $(".product-details .details-nav").addClass("fixed");
            
        } else {
            $(".product-details .details-nav").removeClass("fixed");
            $(".details-nav ul li a").removeClass("active");
        }
    })
})